$(document).ready(function(){
  
  function addItemToCart(variant_id, qty, selling_plan) {
    var data;
    if(selling_plan){
      data = {
        "id": variant_id,
        "quantity": qty,
        "selling_plan": selling_plan
      }
    }else{
      data = {
        "id": variant_id,
        "quantity": qty
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        var quantity = 1;
		$('[data-cart-popup-wrapper]').addClass('is-transitioning');
        $('[data-cart-popup-title]').text($('.grid__item.added').find('.product-title-link').text());
        $('[data-cart-popup-quantity]').text(quantity);
        var imgSrc = $('.grid__item.added .grid-view-item__image').attr('srcset').split(',');
        var imgSrc = imgSrc[1].split(' ');
        var imgEl = '<img src="'+imgSrc[1]+'">';
        $('[data-cart-popup-image-wrapper]').find('img').remove();
		$('[data-cart-popup-image-wrapper]').removeClass('hide').append(imgEl).find('img').addClass('cart-popup-item__image');
        $('.grid__item.added').removeClass('added');
        $('.atc-product-grid').removeClass('disabled');
        
        $.getJSON('/cart.js').then(
          function(cart) {
            $('[data-cart-popup-cart-quantity]').text(cart.item_count);
            $('[data-cart-count]').text(cart.item_count);
        	$('[data-cart-popup-wrapper]').removeClass('cart-popup-wrapper--hidden');
          }
        );
        
      },
      error: function (request, status, error) {
        var errorText = JSON.parse(request.responseText);
        $('.grid__item.added .error-msg').text(errorText.description);
        $('.grid__item.added').removeClass('added');
        $('.atc-product-grid').removeClass('disabled');
      }
    });
  }
  $('.atc-product-grid').on('click', function(){
    var option = $(this).prev().find('.active').attr('data-option');
    if(option == 'subscription'){
      var subscriptionID = $(this).prev().find('.active').attr('data-subscription-id');
      addItemToCart($(this).attr('data-product-id'), 1,subscriptionID);
    }else if(option == 'one-time'){
      addItemToCart($(this).attr('data-product-id'), 1);
    }
    $(this).parents('.grid__item').addClass('added');
    $('.atc-product-grid').addClass('disabled');
  });
  
  $(document).on('click','[data-cart-popup-close]', function(){
    $('[data-cart-popup-wrapper]').addClass('is-transitioning cart-popup-wrapper--hidden');
    setTimeout(function(){ $('[data-cart-popup-wrapper]').removeClass('is-transitioning') }, 400);
  });
  
  $('.grid-view-item .product-options li').on('click', function(){
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
  });
  
  $('.interval-active').on('click',function(){
  	var totalHeight = 0;
    $(this).next().children().each(function(){
      totalHeight = totalHeight + $(this).outerHeight(true);
    });
    var options = $(this).next();
    if($(this).hasClass('active')){
      options.height(0);
      $(this).removeClass('active');
    }else{
      options.height(totalHeight);
      $(this).addClass('active');
    }
  });
  
  $('.interval-options span').on('click',function(){
    var options = $(this).parent();
    options.height(0)
    options.prev().removeClass('active');
    options.prev().find('span').text($(this).text());
    
    var li = $(this).parents('li');
    li.find('.percent-saving').text($(this).attr('data-percent'));
    //li.find('.amount-saving').text($(this).attr('data-amount'));
    li.attr('data-subscription-id',$(this).attr('data-id'));
    
  });
  
  $(document).mouseup(function(e){
    var container = $(".subscription-intervals");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      container.find('.interval-active').removeClass('active');
      container.find('.interval-options').height(0);
    }
  });
  
  $('.mobile-nav__label').on('click', function(){
  	$('.mobile-nav-wrapper').css('transform', 'translateX(400px)');
    $('.site-header__icon').removeClass('mobile-nav--close');
    $('.site-header__icon').addClass('mobile-nav--open');
  });
  
  
});